import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

export function useVideoCallState({ isStudent, lessonId }) {
  const [toast, setToast] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);
  const [studentCanJoinCall, setStudentCanJoinCall] = useState(false);
  const [reactions, setReactions] = useState([]);
  const [reactionsMenuOpen, setReactionsMenuOpen] = useState(false);
  const [dictionaryModalOpen, setDictionaryModalOpen] = useState(false);
  const [chatModalOpen, setChatModalOpen] = useState(false);

  // Student: watch the call channel's presence to detect when teacher has an active call
  useEffect(() => {
    if (!isStudent || !lessonId) return;

    const ch = supabase.channel(`lesson-call-presence-${lessonId}`, {
      config: {
        broadcast: { self: false },
        presence: { key: `student-watcher-${lessonId}` },
      },
    });

    const checkForOffer = () => {
      const state = ch.presenceState();
      const hasTeacherCall = Object.values(state).flat()
        .some(e => e.role === 'teacher' && e.hasOffer);
      setStudentCanJoinCall(hasTeacherCall);
    };

    ch.on('presence', { event: 'sync' }, checkForOffer);
    ch.on('presence', { event: 'join' }, checkForOffer);
    ch.on('presence', { event: 'leave' }, checkForOffer);

    ch.subscribe();

    return () => {
      try { supabase.removeChannel(ch); } catch (_) {}
    };
  }, [isStudent, lessonId]);

  return {
    toast, setToast,
    videoOpen, setVideoOpen,
    studentCanJoinCall, setStudentCanJoinCall,
    reactions, setReactions,
    reactionsMenuOpen, setReactionsMenuOpen,
    dictionaryModalOpen, setDictionaryModalOpen,
    chatModalOpen, setChatModalOpen,
  };
}
